import { useGetFreeSizesSpace, useIsMobile } from '@hts/shared/libs';
import { HtsButton, HtsTypography, HtsVideo } from '@hts/shared/ui';
import { memo, useRef } from 'react';
import { Link } from 'react-router-dom';
import styles from '../styles/DetailedVideo.module.scss';
import video from './Screen Recording 2024-04-17 at 01.24.16.mov';

export const DetailedVideo = memo(() => {
  const containerRef = useRef<HTMLDivElement>(null);
  const bottomContainerRef = useRef<HTMLDivElement>(null);

  const isMobile = useIsMobile();

  const { freeSpaceHeight } = useGetFreeSizesSpace(containerRef, bottomContainerRef);

  return (
    <div className={styles.centerContainer}>
      <div className={styles.container} ref={containerRef}>
        <HtsVideo
          src={video}
          containerClassName={styles.videoContainer}
          containerHeight={freeSpaceHeight}
        />

        <div className={styles.bottomContainer} ref={bottomContainerRef}>
          <div>
            <HtsTypography variant="body2" fontWeight="500">
              Title
            </HtsTypography>

            <HtsTypography variant="caption" fontWeight="500" color="gray11">
              Title
            </HtsTypography>
          </div>

          <div>
            <HtsTypography variant="h2" element="h2">
              $175
            </HtsTypography>

            <Link to="/">
              <HtsButton label="ORDER" className={styles.orderButton} variant="outlined" />
            </Link>
          </div>
        </div>
      </div>
    </div>
  );
});
